import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useFont } from "../contexts/FontContext";
import axios from "axios";
import Page from "../Components/Page";

const BottomBar = () => {
  const [, setError] = useState(null);
  const [bottomData, setBottomData] = useState(null);
  const fontValue = useFont();

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STRAPI_API_URL + "/api/BNB?populate=*")
      .then(({ data }) => {
        setBottomData(data.data);
      })
      .catch((error) => setError(error));
  }, []);

  return (
    <Page isLoading={fontValue?.loading}>
      <div className="top-0 z-10 w-full bg-[#161C30] opacity-50 max-h-60 min-h-[65px]">
        <div className="lg:max-w-[1100px] m-auto ">
          <div className="flex items-start pt-5 pb-5">
            {bottomData?.attributes?.BNBTX_1 != null && (
              <Link to="/" className="lg:pl-2 pl-5">
                <span className={`font-raleway font-bold text-sm text-white`}>
                  {bottomData?.attributes?.BNBTX_1}
                </span>
              </Link>
            )}
            {bottomData?.attributes?.BNBTX_2 != null && (
              <Link to="/contactus" className="lg:pl-10 pl-5">
                <span className={`font-raleway font-bold text-sm text-white`}>
                  {bottomData?.attributes?.BNBTX_2}
                </span>
              </Link>
            )}
            {bottomData?.attributes?.BNBTX_3 != null && (
              <Link to="/contactus" className="lg:pl-10 pl-5">
                <span className={`font-raleway font-bold text-sm text-white`}>
                  {bottomData?.attributes?.BNBTX_3}
                </span>
              </Link>
            )}
            {bottomData?.attributes?.BNBTX_4 != null && (
              <Link to="/data-privacy-policy" className="lg:pl-10 pl-5">
                <span className={`font-raleway font-bold text-sm text-white`}>
                  {bottomData?.attributes?.BNBTX_4}
                </span>
              </Link>
            )}
            {bottomData?.attributes?.BNBTX_5 != null && (
              <Link to="/end-user-license-agreement" className="lg:pl-10 pl-5">
                <span className={`font-raleway font-bold text-sm text-white`}>
                  {bottomData?.attributes?.BNBTX_5}
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default BottomBar;
